import type { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { IKIBusinessPriority } from 'legacy/lut/features/partner360/jbpSettings/models/kiBusinessPriority'
import { ReactNode, useMemo } from 'react'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getCockpitInitiativeRows } from '../../../../lib'
import type {
  CockpitPeriodKey,
  ICockpitKeyInitiative,
  ICockpitPlanningPeriod,
} from '../../../../model/types'
import type { TCockpitExportSlot } from '../../../components/cockpitExport'
import { CockpitInitiativesHierarchy } from '../cockpitInitiativesHierarchy'

interface ICockpitInitiativesViewProps {
  initiatives: ICockpitKeyInitiative[]
  businessPriorities: IKIBusinessPriority[]
  selectedMetric: ActualsValueTypes
  isLocalCurrency: boolean
  selectedPeriods: CockpitPeriodKey[]
  planningPeriod: ICockpitPlanningPeriod | null
  currency: string
  showGeoHierarchy: boolean
  keyObjectives: IKeyObjective[]
  exportSlot?: TCockpitExportSlot
  actions?: ReactNode
}

/** Scoped and period-adjusted initiatives rendered in either hierarchy order when Geo is available. */
export const CockpitInitiativesView = ({
  initiatives,
  businessPriorities,
  selectedMetric,
  isLocalCurrency,
  selectedPeriods,
  planningPeriod,
  currency,
  showGeoHierarchy,
  keyObjectives,
  exportSlot,
  actions,
}: ICockpitInitiativesViewProps) => {
  const rows = useMemo(
    () =>
      getCockpitInitiativeRows({
        initiatives,
        kiBusinessPriorities: businessPriorities,
        selectedMetric,
        isLocalCurrency,
        selectedPeriods,
        planningPeriod,
        keyObjectives,
      }),
    [
      initiatives,
      businessPriorities,
      selectedMetric,
      isLocalCurrency,
      selectedPeriods,
      planningPeriod,
      keyObjectives,
    ]
  )

  return (
    <CockpitInitiativesHierarchy
      rows={rows}
      currency={currency}
      showGeoHierarchy={showGeoHierarchy}
      exportSlot={exportSlot}
      actions={actions}
    />
  )
}

CockpitInitiativesView.displayName = 'CockpitInitiativesView'
